'use strict';

/*
 *	A filter to replace \n in the string to with <br/> for rendering in an html element
 */
angular.module('posApp').filter('newlines', () => (text) => {
  if (text) {
    return text.replace(/\n/g, '<br/>');
  } else {
    return '';
  }
});
